import { UrlConstants } from "../url.constants";
export class ApiRecipientGroupSettingsConstants {
    static URL = UrlConstants.API_V2 + "RecipientGroupSetting";
    static FUNCTION_DELETE_RECIPIENT_GROUP_SETTING = "DeleteMultipleRecipientGroupSettings";
}
